import React, { useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AulaUserContext, { getAulaSession } from './aulaUserContext';
import { AulaPrivateRoute } from './AulaPrivateRoute';
import AulaNavbar from './AulaNavbar';
import Catalogo from './Catalogo/Catalogo';
import CursoDetalle from './CursoDetalle/CursoDetalle';
import ModuloDetalle from './ModuloDetalle/ModuloDetalle';
import AulaLogin from './Login/AulaLogin';
import AulaRegistro from './Registro/AulaRegistro';
import ConfirmarCuenta from './ConfirmarCuenta/ConfirmarCuenta';
import AdminPanel from './Admin/AdminPanel';
import AulaPerfil from './Perfil/AulaPerfil';
import './Aula.css';

// Módulo de Aula Virtual, montado en /aula con su propio router, su propio
// navbar y su propia sesión (aulaUserContext) — separado del sitio institucional.
const AulaApp = () => {
    const [aulaAuth, setAulaAuth] = useState(getAulaSession());

    return (
        <AulaUserContext.Provider value={{ aulaAuth, setAulaAuth }}>
            <div className="aula-wrapper">
                <AulaNavbar />
                <Switch>
                    <Route exact path="/aula/login" component={AulaLogin} />
                    <Route exact path="/aula/registro" component={AulaRegistro} />
                    <Route exact path="/aula/confirmar" component={ConfirmarCuenta} />
                    <Route exact path="/aula" component={Catalogo} />
                    <Route exact path="/aula/curso/:id" component={CursoDetalle} />
                    <AulaPrivateRoute exact path="/aula/curso/:cursoId/modulo/:moduloId" component={ModuloDetalle} />
                    <AulaPrivateRoute exact path="/aula/admin" component={AdminPanel} allowedRoles={['Admin', 'Supervisor']} />
                    <AulaPrivateRoute exact path="/aula/perfil" component={AulaPerfil} />
                    <Redirect to="/aula" />
                </Switch>
            </div>
        </AulaUserContext.Provider>
    );
};

export default AulaApp;
